import React from "react";
import { MDBTable, MDBTableHead, MDBTableBody } from "mdbreact";
import { currency, dateFormat } from "../../../../../../services/utilities";

export default function Collapsable({ procurement }) {
  const { category, status, acquired, price, pm, createdAt, descriptions } =
    procurement;
  // pm is { value, unit }, e.g. every 1 month
  const pmLabel = pm?.unit
    ? `Every ${pm.value || 1} ${pm.unit}${(pm.value || 1) > 1 ? "s" : ""}`
    : "—";
  return (
    <MDBTable bordered>
      <MDBTableHead>
        <tr>
          <th>Category</th>
          <th>Date</th>
          <th>Acquired</th>
          <th>Price</th>
          <th>Status</th>
          <th>PM</th>
          <th>Descriptions</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        <tr>
          <td>
            <h5>{category}</h5>
          </td>
          <td>{dateFormat(createdAt)}</td>
          <td>{acquired}</td>
          <td>{currency.format(price || 0)} </td>
          <td>
            <small>{status}</small>
          </td>
          <td>{pmLabel}</td>
          <td>{descriptions}</td>
        </tr>
      </MDBTableBody>
    </MDBTable>
  );
}
